var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import AddIcon from "@mui/icons-material/Add";
import { Button, Menu, MenuItem } from "@mui/material";
import React from "react";
import { Link as RouterLink } from "react-router-dom";
export var AddActivityMenu = function (_a) {
    var teamId = _a.teamId;
    var _b = __read(React.useState(null), 2), anchorEl = _b[0], setAnchorEl = _b[1];
    var open = Boolean(anchorEl);
    var handleClick = function (event) {
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        setAnchorEl(null);
    };
    return (_jsxs(_Fragment, { children: [_jsx(Button, { variant: "contained", startIcon: _jsx(AddIcon, {}), onClick: handleClick, children: "Add Activity" }), _jsxs(Menu, { anchorEl: anchorEl, open: open, onClose: handleClose, children: [_jsx(MenuItem, { component: RouterLink, to: "/teams/".concat(teamId, "/external-match/create"), children: "Add Match" }), _jsx(MenuItem, { component: RouterLink, to: "/teams/".concat(teamId, "/intra-squad-match/create"), children: "Add Intra-Squad Match" }), _jsx(MenuItem, { component: RouterLink, to: "/teams/".concat(teamId, "/intra-squad-tournaments/create"), children: "Add Intra-Squad Tournament" })] })] }));
};
